import Layout from "../Partials/Layout";
import {Link, useLocation, useHistory} from "react-router-dom";
import api from '../../shared/utils/auth/Index';
import {useState, useEffect} from "react";
import Loader from "../../shared/components/Loader";
import Pagination from "../../shared/components/Pagination";
import useQueryString from '../../shared/utils/queryString';

const List = () => {

    const { search } = useLocation();

    const history = useHistory();

    const [categories, setCategories] = useState(undefined);
    useEffect(() => {
        fetchCategories();
    }, [search]);

    const [filters, setFilters] = useState({});
    const handleFilter = (e) => {
        e.preventDefault();
        let queryString = useQueryString.createQueryStr(search, {
            page: 1,
            ...filters
        });

        history.push({
            search: queryString
        });

        // setCategories(undefined);
    };

    const fetchCategories = () => {
        let url = '/categories'+search;
        api.get(url, {}, (res) => {
            let data = res.data;
            setCategories(data);

        }, (err) => {
            alert('error')
        });
    };

    const onDelete = (id) => {
        id = parseInt(id);

        if (window.confirm()) {
            setCategories(
                {...categories, data: categories.data.filter((cat) => cat.id !== id) }
            );

            deleteItem(id);
        }
    }

    const deleteItem = (id) => {
        let url = `/categories/${id}`;

        api.delete(url, {}, (res) => {

        }, (err) => {
            alert('Error: Item has not deleted');
        });
    }

    if (categories === undefined) return <Layout><Loader/></Layout>;

    return (
        <Layout>
            <div className="font-irs-b">
                <h4 className="d-inline-block ml-4">داشبورد</h4>

                <Link to="/categories/create" className="btn btn-outline-secondary">افزودن دسته بندی</Link>
            </div>
            <hr className="my-1 bold-hr"/>

            <form onSubmit={(e) => handleFilter(e)}>
                <div className="row py-2">
                    <div className="col-auto">
                        <input type="text"
                               value={filters.name}
                               onChange={(e) =>
                                   setFilters({...filters, name: e.target.value})}
                               className="form-control"/>
                    </div>
                    <div className="col-auto">
                        <button type="submit" className="btn btn-outline-primary">جستجو</button>
                    </div>
                </div>
            </form>

            <div className="row">
                <div className="col-12">
                    <table className="table table-striped custom-table">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>نام</th>
                            <th>والد</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {categories.data.map((category, index) => (
                            <tr key={category.id}>
                                <td>
                                    {index+1}
                                </td>
                                <td>
                                    {category.name}
                                </td>
                                <td>
                                    -
                                </td>
                                <td>
                                    <div className="action-part">
                                        <Link to={`categories/${category.id}/update`} className="btn btn-link">ویرایش</Link>
                                        |
                                        <button className="btn btn-link" type="button"
                                                onClick={() => onDelete(category.id)}
                                                style={{textDecoration: 'none'}}>حذف</button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Pagination meta={categories.meta} states={filters}/>
                </div>
            </div>

        </Layout>
    )
}

export default List;
